module.exports = __webpack_public_path__ + "static/media/12_l_woll_0_0.597c1a59.png";